module.exports = __webpack_public_path__ + "static/media/m2.18c84faf.PNG";